import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../../axiosConfig';
import Loading from '../../components/globales/Loading';
import TablaLayout from '../../components/globales/TablaLayout';
import ModalDynamic from '../../components/globales/ModalDynamic';
import useCrud from '../../hooks/useCrud';
import ENDPOINTS from '../../api/endpoints';
import { encuestaSchema } from '../../services/validators';

export default function Encuestas() {
    const navigate = useNavigate();
    const keyField = 'id';

    const initForm = () => ({
        nombre: '',
        objetivo: '',
        id_empresa: '',
        numero_preguntas: '',
        tiempo_desarrollo: ''
    });

    const encuestaEndpoints = useMemo(() => ({
        listar: ENDPOINTS.encuestas.listar,
        crear: ENDPOINTS.encuestas.crear,
        actualizar: ENDPOINTS.encuestas.actualizar,
        borrar: ENDPOINTS.encuestas.borrar
    }), []);

    const [empresas, setEmpresas] = useState([]);
    useEffect(() => {
        axios.get(ENDPOINTS.empresas.listar)
            .then(res => {
                const payload = res.data.data ?? res.data;
                const opts = payload.map(e => ({
                    value: e.codigo_empresa,
                    label: `${e.codigo_empresa} | ${e.nombre_empresa}`
                }));
                setEmpresas(opts);
            })
            .catch(() => {});
    }, []);

    const columns = [
        { label: 'No', key: 'index', align: 'center', render: (_, i) => i + 1 },
        { label: 'Nombre', key: 'nombre', width: '20%' },
        { label: 'Objetivo', key: 'objetivo', as: 'textarea', width: '30%' },
        { label: 'Empresa', key: 'id_empresa', options: empresas, width: '20%',
            // Aquí usamos la fila completa para extraer el id_empresa
            render: (_, idx, row) => {
                const val = row.id_empresa;
                return empresas.find(o => o.value === val)?.label || val;
            }
        },
        { label: 'Nro.Preguntas', key: 'numero_preguntas', type: 'number', align: 'center', width: '10%' },
        { label: 'Tiempo', key: 'tiempo_desarrollo', type: 'time', align: 'center', width: '10%' }
    ];

    const {
        data,
        loading,
        error,
        showModal,
        actionType,
        formData,
        errors,
        openModal,
        closeModal,
        handleChange,
        submit,
        remove
    } = useCrud(encuestaEndpoints, { keyField, initForm, columns, schema: encuestaSchema });
    console.log('formData:', formData);

    
    if (loading) return <Loading mensaje="Cargando Encuestas..." />;
    if (error) return <div className="text-danger">Error: {error.message}</div>;

    return (
        <div className="container">
            <TablaLayout
                title="Encuestas"
                data={data}
                columns={columns}
                keyField={keyField}
                onCreate={() => openModal('crear')}
                onView={item => openModal('consultar', item)}
                onEdit={item => openModal('editar', item)}
                onDelete={remove}
                onNavigate={item => navigate(`/preguntas/${item[keyField]}`)}
                navigateTitle="Agregar Preguntas"
                navigateIcon="note_add"
            />

            <ModalDynamic
                show={showModal}
                accion={actionType}
                title="Encuesta"
                columns={columns}
                formData={formData}
                errors={errors}
                onChange={handleChange}
                onSubmit={submit}
                onClose={closeModal}
            />
        </div>
    );
}
